// ESM shim - React 19 has useSyncExternalStore built-in
export { useSyncExternalStore } from "react";
